import React, { useState, useEffect } from "react";
// import logo from '../img/logo.png';
import Dashboard from "../components/Dashboard-old";

const NavigationBar = () => {
  const [email, setEmail] = useState("");
  const [tooltipText, setTooltipText] = useState("");
  useEffect(() => {
    // Retrieve email address from localStorage
    const email_address = window.localStorage.getItem("email_address");

    // Update the state with the retrieved email address
    setEmail(email_address);
  }, [email]);

  function logout() {
    // Remove session data (example: clear authentication token)
    // For example, if you're using a JWT token:
    // localStorage.removeItem('usw');

    // Clear localStorage
    localStorage.clear();
    window.location.href = "/login"; // Redirect to logout page
  }
  const handleProfile = (data) => {
    let displayName;

    if (data.length > 20) {
      const prefix = data.substring(0, 4); // Get the first 4 characters
      const domain = data.substring(data.indexOf("@")); // Get the domain part starting from '@'
      displayName = prefix + "....." + domain;
    } else {
      displayName = data;
    }
    return displayName;
  };
  const handleMouseOver = () => {
    setTooltipText(email);
  };

  const handleMouseOut = () => {
    setTooltipText("");
  };
  const path = window.location.pathname;
  return (
    <div>
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <a className="nav-link  p-1" data-toggle="dropdown" href="#">
              <div className="user-panel d-flex">
                <div className="image user_div">
                  {/* <img src="dist/img/user.png" class="img-circle elevation-2" alt="User Image"> */}
                  <span className="usercharacter">
                    {email ? email.charAt(0).toUpperCase() : ""}
                  </span>
                </div>
                <div className="info">
                  <span
                    className="d-block f_black"
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    title={email}
                  >
                    {handleProfile(email)}{" "}
                    <i className="fa-solid fa-angle-down" />
                  </span>
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a href="#" className="dropdown-item" onClick={logout}>
                <i className="fa-solid fa-arrow-right-from-bracket mr-2" />{" "}
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <a href="#" className="brand-link logo-switch">
          <img
            src="assets/img/logo_sm.png"
            alt="PPEX"
            className="brand-image-xl logo-xs"
          />
          <img
            src="assets/img/logo.png"
            alt="PPEX"
            className="brand-image-xs logo-xl"
            style={{ left: 60 }}
          />
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}

              <li className="nav-item">
                <a
                  href="/dashboard"
                  className={`nav-link ${
                    path.startsWith("/dashboard") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa fa-solid fa-tachometer" />
                  <p>Dashboard</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/users"
                  className={`nav-link ${
                    path.startsWith("/user") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-users" />
                  <p>Users</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/businesses"
                  className={`nav-link ${
                    path.startsWith("/businesses") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fas fa-briefcase  " />
                  <p>Businesses</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/geotags"
                  className={`nav-link ${
                    path.startsWith("/geotags") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-map-marker-alt" />
                  <p>GeoTags</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/levels"
                  className={`nav-link ${
                    path.startsWith("/level") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-layer-group" />
                  <p>Levels</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/drop_geotag_form"
                  className={`nav-link ${
                    path.startsWith("/drop_geotag_form") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-layer-group" />
                  <p>Drop Geotag</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/notification_details_list"
                  className={`nav-link ${
                    path.startsWith("/notification_details_list") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-layer-group" />
                  <p>Notification Details</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/questions"
                  className={`nav-link ${
                    path.startsWith("/questions") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-layer-group" />
                  <p>Questions</p>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/user_monitor"
                  className={`nav-link ${
                    path.startsWith("/user_monitor") ? "active" : ""
                  }`}
                >
                  <i className="nav-icon fa-solid fa-layer-group" />
                  <p>User monitor</p>
                </a>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </div>
  );
};

export default NavigationBar;
